import type { ISiteSettingsBlok } from "@/bloks/SiteSettings/SiteSettings";
import { getCookie } from "@/lib/Analytics/getCookie";
import useCart from "@/lib/hooks/useCart";

import UI from "./UI";

type Props = {
  children?: React.ReactNode;
  siteSettings?: ISiteSettingsBlok | null;
};

const Layout: React.FC<Props> = ({ children, siteSettings }) => {
  const cart = useCart();
  const cookie = getCookie("trackMe");

  return (
    <UI cart={cart} cookie={cookie} siteSettings={siteSettings}>
      {children}
    </UI>
  );
};

export default Layout;
